//WMS - 入库管理api
import {ServerDistApi} from '@/group-cloud/network/ServerBizApi';
export class getPrepareDetailSelect {
    constructor() {
    }
    protected static groupUrl = '/category';
    // https://api.pre.mzdata.top/data-dist/api/dist/wms/bill/out/list
    // http://47.95.206.72:3001/mock/13/data-dist/api/dist/scanWayBill/initiative
    // http://47.95.206.72:3001/mock/13/data-dist/api/dist/category/list
    //新增商品列表下拉
    public static async getDetailSelectList(data) {
        let uri = this.groupUrl + '/list';
        return await ServerDistApi.send(uri, data);
    }
}


